import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    if (!showEllipsis) {
      for (let i = 1; i <= totalPages; i++) {
        pages?.push(i);
      }
      return pages;
    }

    if (currentPage <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages?.push(i);
      }
      pages?.push('ellipsis');
      pages?.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages?.push(1);
      pages?.push('ellipsis');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages?.push(i);
      }
    } else {
      pages?.push(1);
      pages?.push('ellipsis');
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pages?.push(i);
      }
      pages?.push('ellipsis');
      pages?.push(totalPages);
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <nav className="flex items-center justify-center" style={{ gap: '8px', marginTop: '48px', fontFamily: 'IBM Plex Sans, system-ui, sans-serif' }} aria-label="Pagination">
      <Button
        variant="outline"
        size="icon"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <Icon name="ChevronLeft" size={20} color="currentColor" />
      </Button>
      <div className="flex items-center" style={{ gap: '8px' }}>
        {getPageNumbers()?.map((page, index) => {
          if (page === 'ellipsis') {
            return (
              <span
                key={`ellipsis-${index}`}
                className="px-3 py-2"
                style={{ color: '#9CA3AF' }}
                aria-hidden="true"
              >
                ...
              </span>
            );
          }

          return (
            <Button
              key={page}
              variant={currentPage === page ? 'default' : 'outline'}
              size="icon"
              onClick={() => onPageChange(page)}
              aria-label={`Page ${page}`}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {page}
            </Button>
          );
        })}
      </div>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <Icon name="ChevronRight" size={20} color="currentColor" />
      </Button>
    </nav>
  );
};

export default PaginationControls;